/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CommentaireRapportPreposeDto } from '../models/commentaire-rapport-prepose-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des commentaires des rapports des préposés
 */
@Injectable({
  providedIn: 'root',
})
export class CommentairesRapportsPreposesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation commentaireRapportPreposeLoadList
   */
  static readonly CommentaireRapportPreposeLoadListPath = '/api/commentaires-rapports-preposes/load-list/{rapportPreposeId}';

  /**
   * Renvoie la liste des commentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposeLoadList$Response(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeLoadListPath, 'post');
    if (params) {
      rb.path('rapportPreposeId', params.rapportPreposeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des commentaires (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposeLoadList(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.commentaireRapportPreposeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposeGet
   */
  static readonly CommentaireRapportPreposeGetPath = '/api/commentaires-rapports-preposes/{rapportPreposeId}/{id}';

  /**
   * Renvoie le commentaire du rapport préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGet$Response(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Identifiant du commentaire du rapport préposé à mettre à jour
     */
    id: number;
  }): Observable<StrictHttpResponse<CommentaireRapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeGetPath, 'get');
    if (params) {
      rb.path('rapportPreposeId', params.rapportPreposeId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentaireRapportPreposeDto>;
      })
    );
  }

  /**
   * Renvoie le commentaire du rapport préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGet(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Identifiant du commentaire du rapport préposé à mettre à jour
     */
    id: number;
  }): Observable<CommentaireRapportPreposeDto> {

    return this.commentaireRapportPreposeGet$Response(params).pipe(
      map((r: StrictHttpResponse<CommentaireRapportPreposeDto>) => r.body as CommentaireRapportPreposeDto)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposePut
   */
  static readonly CommentaireRapportPreposePutPath = '/api/commentaires-rapports-preposes/{rapportPreposeId}/{id}';

  /**
   * Met à jour le commentaire du rapport préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePut$Response(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Identifiant du commentaire du rapport préposé à mettre à jour
     */
    id: number;

    /**
     * Commentaire du rapport préposé
     */
    body: CommentaireRapportPreposeDto
  }): Observable<StrictHttpResponse<CommentaireRapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposePutPath, 'put');
    if (params) {
      rb.path('rapportPreposeId', params.rapportPreposeId, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentaireRapportPreposeDto>;
      })
    );
  }

  /**
   * Met à jour le commentaire du rapport préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePut(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Identifiant du commentaire du rapport préposé à mettre à jour
     */
    id: number;

    /**
     * Commentaire du rapport préposé
     */
    body: CommentaireRapportPreposeDto
  }): Observable<CommentaireRapportPreposeDto> {

    return this.commentaireRapportPreposePut$Response(params).pipe(
      map((r: StrictHttpResponse<CommentaireRapportPreposeDto>) => r.body as CommentaireRapportPreposeDto)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposePost
   */
  static readonly CommentaireRapportPreposePostPath = '/api/commentaires-rapports-preposes/{rapportPreposeId}';

  /**
   * Crée le commentaire pour le rapport préposé spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePost$Response(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Commentaire
     */
    body: CommentaireRapportPreposeDto
  }): Observable<StrictHttpResponse<CommentaireRapportPreposeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposePostPath, 'post');
    if (params) {
      rb.path('rapportPreposeId', params.rapportPreposeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentaireRapportPreposeDto>;
      })
    );
  }

  /**
   * Crée le commentaire pour le rapport préposé spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePost(params: {

    /**
     * Identifiant du rapport préposé
     */
    rapportPreposeId: number;

    /**
     * Commentaire
     */
    body: CommentaireRapportPreposeDto
  }): Observable<CommentaireRapportPreposeDto> {

    return this.commentaireRapportPreposePost$Response(params).pipe(
      map((r: StrictHttpResponse<CommentaireRapportPreposeDto>) => r.body as CommentaireRapportPreposeDto)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposePost2
   */
  static readonly CommentaireRapportPreposePost2Path = '/api/commentaires-rapports-preposes';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposePost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePost2$Response(params: {

    /**
     * Entité
     */
    body: CommentaireRapportPreposeDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposePost2Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposePost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePost2(params: {

    /**
     * Entité
     */
    body: CommentaireRapportPreposeDto
  }): Observable<void> {

    return this.commentaireRapportPreposePost2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposeGet2
   */
  static readonly CommentaireRapportPreposeGet2Path = '/api/commentaires-rapports-preposes/{id}';

  /**
   * Renvoie l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeGet2()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGet2$Response(params: {

    /**
     * Identifiant de l&#x27;entité
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeGet2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeGet2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGet2(params: {

    /**
     * Identifiant de l&#x27;entité
     */
    id: number;
  }): Observable<void> {

    return this.commentaireRapportPreposeGet2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposePut2
   */
  static readonly CommentaireRapportPreposePut2Path = '/api/commentaires-rapports-preposes/{id}';

  /**
   * Met à jour l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposePut2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePut2$Response(params: {

    /**
     * Identifiant de l&#x27;entité à mettre à jour
     */
    id: number;

    /**
     * Entité
     */
    body: CommentaireRapportPreposeDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposePut2Path, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Met à jour l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposePut2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposePut2(params: {

    /**
     * Identifiant de l&#x27;entité à mettre à jour
     */
    id: number;

    /**
     * Entité
     */
    body: CommentaireRapportPreposeDto
  }): Observable<void> {

    return this.commentaireRapportPreposePut2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposeDelete
   */
  static readonly CommentaireRapportPreposeDeletePath = '/api/commentaires-rapports-preposes/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.commentaireRapportPreposeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposeGetList
   */
  static readonly CommentaireRapportPreposeGetListPath = '/api/commentaires-rapports-preposes/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentaireRapportPreposeGetList(params?: {
  }): Observable<void> {

    return this.commentaireRapportPreposeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commentaireRapportPreposeLoadList2
   */
  static readonly CommentaireRapportPreposeLoadList2Path = '/api/commentaires-rapports-preposes/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentaireRapportPreposeLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposeLoadList2$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, CommentairesRapportsPreposesService.CommentaireRapportPreposeLoadList2Path, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commentaireRapportPreposeLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentaireRapportPreposeLoadList2(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.commentaireRapportPreposeLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
